import axiosInstance from "./config/axios"

export const listAllProducts = async () => await axiosInstance.post("/services/search")

export const listProductsWithLimit = async (organization: any) =>
	await axiosInstance.get(`/organizations/${organization}/freeServiceLimits`)
